'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var web3_js = require('@solana/web3.js');

/** @group Constants */
const WRAPPED_SOL_MINT = new web3_js.PublicKey('So11111111111111111111111111111111111111112');

exports.WRAPPED_SOL_MINT = WRAPPED_SOL_MINT;
//# sourceMappingURL=constants.cjs.map
